<h1 mat-dialog-title class="az-blue-text">Switching to {{modeName | translate}} mode?
</h1>
<div mat-dialog-content class="azavista-vertical-stack">
    <h4> Are you sure that you want to switch to {{modeName | translate}} mode? </h4>
</div>

<div mat-dialog-actions class="dialog-actions">
    <div class="azavista-horizontal-stack">
        <azavista-button (click)="onCancelClick()" class="azavista-onsite-button cancel-button">
            <span translate>CANCEL</span>
        </azavista-button>
        <azavista-button (click)="onSwitchMode()" class="azavista-onsite-button save-button primary-button ">
            <span translate>SWITCH</span>
        </azavista-button>
    </div>
</div>